// extracted by mini-css-extract-plugin
module.exports = {"button_wrapper":"button-with-icon_button_wrapper___ZBqI","button":"button-with-icon_button__1_woE","text_wrapper":"button-with-icon_text_wrapper__2Q0bi"};